






















import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import { Menu } from '@/services/Menus'
import vueRouter from '@/router'
import * as _ from 'lodash'
import {Getter, Action} from 'vuex-class'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'

@Component
export default class CopytextComponent extends VueExtendedBaseComponent {

  @Prop({default: '-'}) private text!: string

  @Prop() private limit!: number

  get tooltip() {
    return this.limit && (this.text.length > this.limit)
  }

  private copyToClipboard(text: string) {
    const message: { txt: string, type: 'success' | 'error' } = {
      txt: `You just copied: ${text}`,
      type: 'success',
    }
    // if (navigator.share) {
    //   navigator
    //     .share({
    //       title: 'Share',
    //       text,
    //     })
    //     .then(() => (message.txt = 'Successful share'))
    //     .catch((err: Error) => {
    //       const skipErr = () => err
    //       skipErr()
    //       message.txt = 'Error sharing'
    //       message.type = 'error'
    //     })
    // } else {
    let result

    try {
      document.addEventListener('copy', (e: ClipboardEvent) => {
        if (e.clipboardData) {
          e.clipboardData.setData('text/plain', text)
        }
        e.preventDefault()
      })
      result = document.execCommand('copy')
      if (!result) {
        window.onblur = () => {
          result = document.execCommand('copy')
          window.off('blur')
        }
        window.blur()
      }
    } catch (err) {
      console.log(err)
      const skipErr = () => err
      skipErr()
      result = null
    }

    // manual copy fallback using prompt
    if (!result) {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
      const copyHotkey = isMac ? '⌘C' : 'copy'
      return prompt(`Press ${copyHotkey}`, text) // eslint-disable-line no-alert
    }
    // }
    this.updateSnackbar(message)
    return true
  }
}
